import { motion } from "framer-motion";
import { Leaf } from "lucide-react";

const IMG =
  "https://static.prod-images.emergentagent.com/jobs/a2c59b25-30f1-4359-838d-3ea682316c82/images/7401dec1dc9b42e609f08cf97b8e1a06eccd423f853735703dc142b0084e86f5.png";

export const Sustainability = () => {
  return (
    <section
      id="sustainability"
      className="relative py-24 md:py-36 bg-cream"
      data-testid="sustainability-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9 }}
          className="lg:col-span-6 order-2 lg:order-1"
        >
          <div className="flex items-center gap-3 mb-6">
            <Leaf size={20} className="text-sage" strokeWidth={1.5} />
            <span className="uppercase text-xs tracking-[0.3em] text-sage">
              Sustainable by design
            </span>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-forest leading-[1.05] tracking-tight">
            Green is in our name —
            <br />
            and our practice.
          </h2>
          <div className="divider-line my-10" />
          <p className="text-graphite text-base md:text-lg leading-relaxed max-w-xl">
            We choose eco-conscious methods, energy-efficient solutions and
            responsibly-sourced materials wherever possible. The goal isn't only a
            well-maintained estate — it's one that's lighter on the planet, kinder
            to its residents, and built to last.
          </p>

          <div className="grid grid-cols-3 gap-6 mt-12">
            {[
              { v: "Low", l: "Water Solutions" },
              { v: "LED", l: "Lighting Upgrades" },
              { v: "Eco", l: "Materials & Methods" },
            ].map((s) => (
              <div key={s.l} className="border-t border-bordersoft pt-4">
                <div className="font-serif text-2xl text-forest">{s.v}</div>
                <div className="uppercase text-[10px] tracking-[0.2em] text-sage mt-1">
                  {s.l}
                </div>
              </div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1 }}
          className="lg:col-span-6 order-1 lg:order-2"
        >
          <div className="relative">
            <img
              src={IMG}
              alt="Sustainable green estate landscape"
              className="w-full h-[560px] object-cover"
            />
            <div className="absolute -top-4 -left-4 w-24 h-24 bg-gold flex items-center justify-center">
              <Leaf size={36} className="text-forest" strokeWidth={1.25} />
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Sustainability;
